function Jamaica({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_521_1416)">
        <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#FFDA44"/>
        <path d="M25.741 3.3075C23.043 1.23369 19.6658 0 16 0C12.3341 0 8.95685 1.23375 6.25891 3.3075L16 13.0485L25.741 3.3075Z" fill="#6DA544"/>
        <path d="M3.30744 6.25879C1.23375 8.95673 0 12.3339 0 15.9998C0 19.6657 1.23375 23.0429 3.3075 25.7409L13.0486 15.9998L3.30744 6.25879Z" fill="black"/>
        <path d="M6.25891 28.6927C8.95691 30.7665 12.3341 32.0002 16 32.0002C19.6658 32.0002 23.043 30.7664 25.741 28.6927L16 18.9517L6.25891 28.6927Z" fill="#6DA544"/>
        <path d="M28.6925 25.7408C30.7663 23.0429 32 19.6657 32 15.9998C32 12.3339 30.7663 8.95673 28.6925 6.25879L18.9515 15.9998L28.6925 25.7408Z" fill="black"/>
      </g>
    </svg>
  `;

  return baseXml;
}

export default Jamaica;
